import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import jsPDF from "jspdf"
import autoTable, { UserOptions } from "jspdf-autotable";

import '../../../styles/recibo.css'
import { generalShowLoader } from "../../../actions/general.actions"
import { ModalBase } from "../../../components/Modals/ModalBase"
import { formatDateToDDMMYYYY } from "../../../utils/strings.utils"

interface PropsModalPrint {
  datosRecibo?: any,
  onResult: () => void
}

export const ModalRecibo = ({datosRecibo, onResult}: PropsModalPrint) => {
  const dispatch = useDispatch()

  const divRef = useRef<HTMLDivElement | null> (null)

  const onClickPrint = async() => {
    dispatch(generalShowLoader(true))

    const pdf = new jsPDF()
    generatePDFAccount(pdf, datosRecibo)
    pdf.output('dataurlnewwindow')

    onResult();
    dispatch(generalShowLoader(false))
  }

  const generatePDFAccount = (pdf: jsPDF, accountSelected: any) => {
    const titleCellStyle:any = {halign: 'center', valign: 'middle', fillColor: '#13AD90', fontSize: 12, fontStyle: 'bold', textColor: '#FFF', lineWidth: 0.5, lineColor: '#13AD90'}
    const contentCellStyle: any =  {halign: 'left', valign: 'middle', lineWidth: 0.5, lineColor: '#13AD90', fillColor: '#f3f3f3'}
    const detallePago: UserOptions = {
      head: [
        [{content: 'Detalle de Pago', colSpan: 4, styles: {halign: 'left', valign: 'middle', fillColor: '#FFFFFF', fontSize: 16, fontStyle: 'bold', textColor: '#000000', cellPadding: 4, lineWidth: 0.5, lineColor: '#13AD90'}}],
      ],
      body: [
        [{content: 'Empresa', colSpan: 2, styles: titleCellStyle}, {content: 'Correo electrónico', colSpan: 2, styles: titleCellStyle}],
        [{content: accountSelected?.detalle_impresion?.empresa, colSpan: 2, styles: contentCellStyle}, {content: accountSelected?.detalle_impresion?.correo, colSpan: 2, styles: contentCellStyle}],
        [{content: 'Dirección', colSpan: 2, styles: titleCellStyle}, {content: 'Teléfono', colSpan: 2, styles: titleCellStyle}],
        [{content: accountSelected?.detalle_impresion?.direccion, colSpan: 2, styles: contentCellStyle}, {content: `+${accountSelected?.detalle_impresion?.telefono}`, colSpan: 2, styles: contentCellStyle}],
        [{content: 'Departamento', colSpan: 2, styles: titleCellStyle}, {content: 'Municipio', colSpan: 2, styles: titleCellStyle}],
        [{content: accountSelected?.detalle_impresion?.departamento, colSpan: 2, styles: contentCellStyle}, {content: accountSelected?.detalle_impresion?.municipio, colSpan: 2, styles: contentCellStyle}],
        [{content: `No. Recibo ${accountSelected?.detalle_impresion?.no_recibo}`, colSpan: 4, styles: {...contentCellStyle, minCellHeight: 10, fontSize: 14, fontStyle: 'bold', cellPadding: 4}}],
        [{content: 'Fecha', styles: titleCellStyle}, {content: 'Descripción', styles: titleCellStyle}, {content: 'Periodo del servicio', styles: titleCellStyle}, {content: 'Total', styles: titleCellStyle}],
        [formatDateToDDMMYYYY(accountSelected?.detalle_impresion?.fecha_inicial), accountSelected?.detalle_impresion?.descripcion?.replace(/<br\/>/g, `\n`), `Desde: ${formatDateToDDMMYYYY(accountSelected?.detalle_impresion?.fecha_inicial)} ${accountSelected?.detalle_impresion?.fecha_final ? `Hasta: ${formatDateToDDMMYYYY(accountSelected?.detalle_impresion?.fecha_final)}` : ''}`, parseFloat(accountSelected?.detalle_impresion?.total_factura)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})],
        [' ', ' ', {content: 'Total', styles: titleCellStyle}, {content: parseFloat(accountSelected?.detalle_impresion?.total_factura)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}), styles: titleCellStyle}]
      ],
      styles: {overflow: 'linebreak', /*lineWidth: 0.5, lineColor: '#68a89c'*/},
      margin: {top: 50}
    }
    autoTable(pdf, detallePago)
  }

  return (
    <ModalBase>
      <div className="modal-card" style={{gap: '20px', display: 'flex', flexDirection: 'column'}}>
        <div className="modal-edit-title">
          <h3 className="card-title">IMPRIMIR RECIBO</h3>
          <div className="separador"></div>
        </div>
        <div>¿Deseas imprimir este comprobante?</div>
        <div className="separador"></div>
        <div className="modal-print-container" ref={divRef}>
          <DetallePago 
            data={datosRecibo} 
            fecha={datosRecibo?.fecha_creacion}
          />
        </div>
        <div className="w-layout-hflex button-actions">
          <button className='m button transparent w-inline-block' onClick={() => {onResult();}}>Cancelar</button>
          <button className='m button w-inline-block' onClick={onClickPrint}>Imprimir</button>
        </div>
      </div>
    </ModalBase>
  )
}

export const DetallePago = ({data, fecha} : {data: any, fecha: any}) => {
  return (
    <div className="detalle-pago-container">
      <label className="detalle-pago-title">DETALLE DE PAGO</label>
      <div className="separador"></div>
      <div className="detalle-pago-info">
        <div className="detalle-pago-info-section">
          <label className="detalle-pago-info-title">Empresa</label>
          <label>{data.empresa}</label>
          <label>{data.telefono}</label>
          <label>{data.direccion}</label>
          <label className="detalle-pago-info-title">Departamento de la empresa</label>
          <label>{data.departamento}</label>
        </div>
        <div className="detalle-pago-info-section">
          <label className="detalle-pago-info-title">Correo electrónico</label>
          <label>{data.correo}</label>
          <label className="detalle-pago-info-title">Teléfono de la empresa</label>
          <label>+{data.telefono}</label>
          <label className="detalle-pago-info-title">Municipio de la empresa</label>
          <label>{data.municipio}</label>
        </div>
      </div>
      <div className="separador"></div>
      <label>{`Recibo No. ${data.no_recibo}`}</label>
      <div className="separador"></div>
      <div className="tab-plane">
        <table className="table-main-responsive responsive-table-main td-left table-pointer">
          <thead>
            <tr>
              <td>Fecha</td>
              <td>Descripción</td>
              <td>Período del Servicio</td>
              <td>Total</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label = 'Fecha'>{formatDateToDDMMYYYY(fecha) || ''}</td>
              <td data-label = 'Descripción'><div dangerouslySetInnerHTML={{ __html: data.descripcion }} /></td>
              <td data-label = 'Período del servicio'>{`${formatDateToDDMMYYYY(data.fecha_inicial) || ''} - ${formatDateToDDMMYYYY(data.fecha_final) || ''}`}</td>
              <td data-label = 'Total'>{parseFloat(data.total_factura || '0')?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
            </tr>
            <tr>
              <td data-label = 'Total General' colSpan={2}/>
              <td style={{textAlign: 'right'}}>Total</td>
              <td>{parseFloat(data.total_factura || '0')?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}